module.exports = __webpack_public_path__ + "img/pro_01report.d23834ae.png";